import { TabProps, TabProp, CustomTabs } from './custom-tabs';
import { CvParsingLoadingState } from './cv-parsing-loading-state';

export type { TabProps, TabProp };

export const Tabs = CustomTabs;
export { CvParsingLoadingState };
